import React, { useState, useEffect } from "react";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { useSelector } from "react-redux";
import RcsBulkMessageModal from "../RcsBulkMessage/RcsBulkMessageModal";
import { CircularProgress } from "@mui/material";
import {
  FaRegCalendarAlt,
  FaReply,
  FaPhoneAlt,
  FaGlobeAsia,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Swal from "sweetalert2";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import { TiPlus } from "react-icons/ti";

const RCSStandaloneMsg = ({ activeTab, fetchData, activeLabel }) => {
  const [errors, setErrors] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [checking, setChecking] = useState(false);
  const [capabilityResult, setCapabilityResult] = useState("");
  const loggedInUserName = sessionStorage.getItem("username");
  const [isVerified, setIsVerified] = useState(false);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [geoError, setGeoError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [verifiedPhones, setVerifiedPhones] = useState([]);
  const [bulkFileName, setBulkFileName] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [bulkType, setBulkType] = useState("");
  const [isNameRequired, setIsNameRequired] = useState(false);

  console.log("::bulkType::", bulkType);

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    contacts: "",
    cardOrientation: "VERTICAL",
    cardTitle: "",
    cardDescription: "",
    fileUrl: "",
    plainText: "",
    url: "",
    calendarStartTime: "",
    calendarEndTime: "",
    calendarTitle: "",
    calendarDescription: "",
    latitude: "",
    longitude: "",
    locationLabel: "",
    phoneNumber: "",
    dialerPlainText: "",
    bulkFileName: bulkFileName?.name,
    campaignID: "",
  });

  const { rcsAgentId } = useSelector((state) => state.auth);

  const getDefaultPlainText = (tab) =>
    tab === "STANDALONE_DIALER" || tab === "STANDALONE_COMBINED"
      ? "Visit Now"
      : "Visit Now";

  useEffect(() => {
    setFormData({
      contacts: "",
      cardOrientation: "VERTICAL",
      cardTitle: "",
      cardDescription: "",
      fileUrl: "",
      plainText:
        activeTab === "STANDALONE_REPLY"
          ? "Yes, Absolutely"
          : activeTab === "STANDALONE_CALENDAR"
          ? "Mark Your Calendar"
          : activeTab === "STANDALONE_DIALER"
          ? "Dial Now"
          : getDefaultPlainText(activeTab),
      url: "",
      calendarStartTime: "",
      calendarEndTime: "",
      calendarTitle: "",
      calendarDescription: "",
      latitude: "",
      longitude: "",
      locationLabel: "",
      phoneNumber: "",
      dialerPlainText: activeTab === "STANDALONE_COMBINED" ? "Dial Now" : "",
      bulkFileName: bulkFileName?.name,
      campaignID: "",
    });
    setErrors({});
    setVerifiedPhones([]);
    setCapabilityResult("");
    setGeoError("");

    // Fetch current location if activeTab is "location"
    if (activeTab === "STANDALONE_LOCATION" && navigator.geolocation) {
      if (!navigator.geolocation) {
        console.error("❌ Geolocation API not supported");
        setGeoError("Geolocation is not supported by this browser.");
      } else {
        console.log("✅ Geolocation supported, requesting position...");

        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log("📍 Position fetched:", position.coords);
            setFormData((prev) => ({
              ...prev,
              latitude: position.coords.latitude.toFixed(6),
              longitude: position.coords.longitude.toFixed(6),
            }));
            setGeoError("");
          },
          (error) => {
            console.error("Geolocation error:", error.code, error.message);
            setGeoError(
              error.code === error.PERMISSION_DENIED
                ? "Location access denied. Please enable location permissions."
                : "Unable to fetch location. Please try again."
            );
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      }
    }
  }, [activeTab, bulkFileName]);

  useEffect(() => {
    setIsVerified(false);
    setIsBulkUpload(false);
    setBulkFileName(null);
    setBulkType("");
  }, [activeTab]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "contacts") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length > 10) return;

      setFormData((prev) => ({ ...prev, [name]: digitsOnly }));
      setCapabilityResult("");

      setIsVerified(verifiedPhones.includes(digitsOnly));
    } else if (name === "phoneNumber") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length > 10) return;

      setFormData((prev) => ({ ...prev, [name]: digitsOnly }));
    } else if (name === "campaignID") {
      if (formData.campaignID === "" && value.trim() !== "") {
        const now = new Date();
        const hours = now.getHours();
        if (hours < 9 || hours >= 21) {
          CustomAlert({
            title: "Info",
            text: "RCS services are available only between 9 AM to 9 PM. Please try later.",
            icon: "info",
            confirmButtonText: "Okay",
            allowOutsideClick: false,
          });
          return;
        }
      }
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateField = (name, value) => {
    const newErrors = {};
    const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/i;
    const repetitiveNumberPattern = /^(\d)\1{9}$/;
    const phonePattern = /^\+91[1-9]\d{9}$/;
    const startsWith6789 = /^[6789]\d{9}$/;
    const specialCharPattern = /[^a-zA-Z0-9\s.,:;'"()\-–—‘’“”&]/;
    const campaignIDRegex = /^[A-Za-z0-9 _-]{4,50}$/;

    switch (name) {
      case "contacts":
        if (!isBulkUpload) {
          if (!value) {
            newErrors.contacts = "Contact is required";
          } else if (value.length < 10) {
            newErrors.contacts = "Phone number must be at least 10 digits";
          } else if (!startsWith6789.test(value)) {
            newErrors.contacts = "Phone number must start with 6, 7, 8, or 9";
          } else if (repetitiveNumberPattern.test(value)) {
            newErrors.contacts = "Repetitive phone numbers are not allowed";
          }
        }
        break;
      case "cardOrientation":
        if (!value || value.trim() === "") {
          newErrors.cardOrientation = "Card Orientation is required";
        } else if (!["VERTICAL", "HORIZONTAL"].includes(value)) {
          newErrors.cardOrientation = "Please select a valid orientation";
        }
        break;
      case "cardTitle":
        if (!value || value.trim() === "") {
          newErrors.cardTitle = "Card Title is required";
        } else if (value.length < 2) {
          newErrors.cardTitle = "Card Title must be at least 2 characters";
        } else if (value.length > 100) {
          newErrors.cardTitle = "Card Title must be 100 characters or less";
        } else if (specialCharPattern.test(value)) {
          newErrors.cardTitle =
            "Card Title must not contain special characters";
        }
        break;
      case "cardDescription":
        if (!value || value.trim() === "") {
          newErrors.cardDescription = "Card Description is required";
        } else if (value.length < 2) {
          newErrors.cardDescription =
            "Card Description must be at least 2 characters";
        } else if (value.length > 500) {
          newErrors.cardDescription =
            "Card Description must be 500 characters or less";
        } else {
          if (bulkType === "name") {
            // Require {{Name}} in the description
            if (!/\{\{Name\}\}/.test(value)) {
              newErrors.cardDescription =
                "Card Description must include {{Name}} placeholder";
            } else {
              // Match allowed placeholders: {{Name}}, {{Address}}, etc.
              const allowedPattern = /\{\{[A-Za-z0-9_ ]+\}\}/g;
              const valueWithoutPlaceholders = value.replace(
                allowedPattern,
                ""
              );

              // Check for other disallowed special characters
              if (specialCharPattern.test(valueWithoutPlaceholders)) {
                newErrors.cardDescription =
                  "Card Description must not contain special characters (except placeholders like {{Name}})";
              }
            }
          } else {
            // For other bulk types, reject all special characters
            if (specialCharPattern.test(value)) {
              newErrors.cardDescription =
                "Card Description must not contain special characters";
            }
          }
        }
        break;
      case "fileUrl":
        if (!value || value.trim() === "") {
          newErrors.fileUrl = "File URL is required";
        } else if (!urlPattern.test(value)) {
          newErrors.fileUrl =
            "Please enter a valid URL starting with http:// or https://";
        }
        break;
      case "plainText":
        if (!value || value.trim() === "") {
          newErrors.plainText = "Plain Text is required";
        } else if (value.length < 2) {
          newErrors.plainText = "Plain Text must be at least 2 characters";
        } else if (value.length > 50) {
          newErrors.plainText = "Plain Text must be 50 characters or less";
        }
        break;
      case "url":
        if (activeTab === "STANDALONE_REPLY") {
          break; // skip validation if activeTab is reply
        }
        if (!value || value.trim() === "") {
          newErrors.url = "URL is required";
        } else if (!urlPattern.test(value)) {
          newErrors.url =
            "Please enter a valid URL starting with http:// or https://";
        }
        break;
      case "calendarStartTime":
        if (activeTab === "STANDALONE_CALENDAR") {
          if (!value) {
            newErrors.calendarStartTime = "Start Time is required";
          } else {
            const year = new Date(value).getFullYear();
            if (year < 2023 || year > 2035) {
              newErrors.calendarStartTime =
                "Year must be between 2023 and 2035";
            }
          }
        }
        break;
      case "calendarEndTime":
        if (activeTab === "STANDALONE_CALENDAR") {
          if (!value) {
            newErrors.calendarEndTime = "End Time is required";
          } else if (value <= formData.calendarStartTime) {
            newErrors.calendarEndTime = "End Time must be after Start Time";
          } else {
            const year = new Date(value).getFullYear();
            if (year < 2023 || year > 2035) {
              newErrors.calendarEndTime = "Year must be between 2023 and 2035";
            }
          }
        }
        break;
      case "calendarTitle":
        if (activeTab === "STANDALONE_CALENDAR") {
          if (!value || value.trim() === "") {
            newErrors.calendarTitle = "Calendar Title is required";
          } else if (value.length < 2) {
            newErrors.calendarTitle =
              "Calendar Title must be at least 2 characters";
          } else if (value.length > 100) {
            newErrors.calendarTitle =
              "Calendar Title must be 100 characters or less";
          }
        }
        break;
      case "calendarDescription":
        if (activeTab === "STANDALONE_CALENDAR") {
          if (!value || value.trim() === "") {
            newErrors.calendarDescription = "Calendar Description is required";
          } else if (value.length < 2) {
            newErrors.calendarDescription =
              "Calendar Description must be at least 2 characters";
          } else if (value.length > 500) {
            newErrors.calendarDescription =
              "Calendar Description must be 500 characters or less";
          }
        }
        break;
      case "latitude":
        if (activeTab === "STANDALONE_LOCATION") {
          if (!value) {
            newErrors.latitude = "Latitude is required";
          } else if (isNaN(value) || value < -90 || value > 90) {
            newErrors.latitude = "Latitude must be a number between -90 and 90";
          }
        }
        break;
      case "longitude":
        if (activeTab === "STANDALONE_LOCATION") {
          if (!value) {
            newErrors.longitude = "Longitude is required";
          } else if (isNaN(value) || value < -180 || value > 180) {
            newErrors.longitude =
              "Longitude must be a number between -180 and 180";
          }
        }
        break;
      case "locationLabel":
        if (activeTab === "STANDALONE_LOCATION") {
          if (!value || value.trim() === "") {
            newErrors.locationLabel = "Location Label is required";
          } else if (value.length < 2) {
            newErrors.locationLabel =
              "Location Label must be at least 2 characters";
          } else if (value.length > 100) {
            newErrors.locationLabel =
              "Location Label must be 100 characters or less";
          }
        }
        break;

      case "phoneNumber":
        if (activeTab === "STANDALONE_DIALER") {
          if (!value) {
            newErrors.phoneNumber = "Phone Number is required";
          } else if (value.length < 10) {
            newErrors.phoneNumber = "Phone number must be at least 10 digits";
          } else if (!startsWith6789.test(value)) {
            newErrors.phoneNumber =
              "Phone number must start with 6, 7, 8, or 9";
          } else if (repetitiveNumberPattern.test(value)) {
            newErrors.phoneNumber = "Repetitive phone numbers are not allowed";
          }
        }
        break;
      case "dialerPlainText":
        if (activeTab === "STANDALONE_COMBINED") {
          if (!value || value.trim() === "") {
            newErrors.dialerPlainText = "Dialer Plain Text is required";
          } else if (value.length < 2) {
            newErrors.dialerPlainText =
              "Dialer Plain Text must be at least 2 characters";
          } else if (value.length > 50) {
            newErrors.dialerPlainText =
              "Dialer Plain Text must be 50 characters or less";
          }
        }
        break;

      case "campaignID":
        if (!value || value.trim() === "") {
          newErrors.campaignID = "Campaign ID is required";
        } else if (!campaignIDRegex.test(value.trim())) {
          newErrors.campaignID =
            "Campaign ID must be 4-20 characters: only letters, numbers, spaces, _ or - allowed";
        }
        break;

      default:
        break;
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldErrors = validateField(name, value);
    setErrors((prev) => ({ ...prev, ...fieldErrors }));
  };

  const checkCapability = async () => {
    if (isBulkUpload) return;

    const phone = formData.contacts;

    if (!phone) {
      setCapabilityResult("⚠️ Please enter a valid phone number");
      return false;
    }

    setChecking(true);
    try {
      const headers = {
        rcskey: rcsAgentId,
        "Content-Type": "application/json",
      };

      const payload = {
        PhoneNumbers: [`+91${phone}`],
        username: loggedInUserName,
      };

      console.log("Sending checkCapability request:", {
        url: apiList.CHECK_CAPABILITY,
        headers,
        payload,
      });

      const response = await axiosPostApi(
        apiList.CHECK_CAPABILITY,
        payload,
        headers
      );

      console.log("checkCapability response:", response?.data);

      if (response?.data?.meta?.status === "00" && response?.data?.data?.[0]) {
        setIsVerified(true);
        setVerifiedPhones((prev) => [...prev, phone]);
        CustomAlert({
          title: "Success",
          text: response?.data?.meta?.message,
          icon: "success",
          confirmButtonText: "Okay",
          allowOutsideClick: false,
        });
      } else {
        setIsVerified(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.meta?.message,
          icon: "error",
          confirmButtonText: "Okay",
          allowOutsideClick: false,
        });
      }
    } catch (err) {
      console.error("checkCapability error:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers,
      });
      setCapabilityResult(
        `⚠️ Network Error: ${err.message}${
          err.response?.status ? ` (Status: ${err.response.status})` : ""
        }`
      );
    } finally {
      setChecking(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/i;
    const repetitiveNumberPattern = /^(\d)\1{9}$/;
    const phonePattern = /^\+91[1-9]\d{9}$/;
    const startsWith6789 = /^[6789]\d{9}$/;
    const specialCharPattern = /[^a-zA-Z0-9\s.,:;'"()\-–—‘’“”&]/;
    const campaignIDRegex = /^[A-Za-z0-9 _-]{4,50}$/;

    // Contact validation
    if (!isBulkUpload) {
      const contact = formData.contacts ? formData.contacts.trim() : "";

      if (!contact) {
        newErrors.contacts = "Contact is required";
      } else if (contact.length < 10) {
        newErrors.contacts = "Phone number must be at least 10 digits";
      } else if (!startsWith6789.test(contact)) {
        newErrors.contacts = "Phone number must start with 6, 7, 8, or 9";
      } else if (repetitiveNumberPattern.test(contact)) {
        newErrors.contacts = "Repetitive phone numbers are not allowed";
      }
    }

    if (!formData?.campaignID?.trim()) {
      newErrors.campaignID = "Campaign ID is required";
    } else if (!campaignIDRegex.test(formData.campaignID.trim())) {
      newErrors.campaignID =
        "Campaign ID must be 4-20 characters: only letters, numbers, spaces, _ or - allowed";
    }

    // Card Orientation validation
    if (!formData.cardOrientation || formData.cardOrientation.trim() === "") {
      newErrors.cardOrientation = "Card Orientation is required";
    } else if (!["VERTICAL", "HORIZONTAL"].includes(formData.cardOrientation)) {
      newErrors.cardOrientation = "Please select a valid orientation";
    }

    // Card Title validation
    if (!formData.cardTitle || formData.cardTitle.trim() === "") {
      newErrors.cardTitle = "Card Title is required";
    } else if (formData.cardTitle.length < 2) {
      newErrors.cardTitle = "Card Title must be at least 2 characters";
    } else if (formData.cardTitle.length > 100) {
      newErrors.cardTitle = "Card Title must be 100 characters or less";
    } else if (specialCharPattern.test(formData.cardTitle)) {
      newErrors.cardTitle = "Card Title must not contain special characters";
    }

    // Card Description validation
    if (!formData.cardDescription || formData.cardDescription.trim() === "") {
      newErrors.cardDescription = "Card Description is required";
    } else if (formData.cardDescription.length < 2) {
      newErrors.cardDescription =
        "Card Description must be at least 2 characters";
    } else if (formData.cardDescription.length > 500) {
      newErrors.cardDescription =
        "Card Description must be 500 characters or less";
    } else {
      if (bulkType === "name") {
        // Require {{Name}} in the description
        if (!/\{\{Name\}\}/.test(formData.cardDescription)) {
          newErrors.cardDescription =
            "Card Description must include {{Name}} placeholder";
        } else {
          // Allow placeholders like {{Name}}, {{Address}}, etc.
          const allowedPattern = /\{\{[A-Za-z0-9_ ]+\}\}/g;
          const valueWithoutPlaceholders = formData.cardDescription.replace(
            allowedPattern,
            ""
          );

          if (specialCharPattern.test(valueWithoutPlaceholders)) {
            newErrors.cardDescription =
              "Card Description must not contain special characters (except placeholders like {{Name}})";
          }
        }
      } else {
        // For other bulk types, disallow all special characters
        if (specialCharPattern.test(formData.cardDescription)) {
          newErrors.cardDescription =
            "Card Description must not contain special characters";
        }
      }
    }

    // File URL validation
    if (!formData.fileUrl || formData.fileUrl.trim() === "") {
      newErrors.fileUrl = "File URL is required";
    } else if (!urlPattern.test(formData.fileUrl)) {
      newErrors.fileUrl =
        "Please enter a valid URL starting with http:// or https://";
    }

    // Plain Text validation
    if (!formData.plainText || formData.plainText.trim() === "") {
      newErrors.plainText = "Plain Text is required";
    } else if (formData.plainText.length < 2) {
      newErrors.plainText = "Plain Text must be at least 2 characters";
    } else if (formData.plainText.length > 50) {
      newErrors.plainText = "Plain Text must be 50 characters or less";
    }

    // URL validation
    if (
      activeTab !== "STANDALONE_REPLY" &&
      activeTab !== "STANDALONE_CALENDAR" &&
      activeTab !== "STANDALONE_DIALER"
    ) {
      if (!formData.url || formData.url.trim() === "") {
        newErrors.url = "URL is required";
      } else if (!urlPattern.test(formData.url)) {
        newErrors.url =
          "Please enter a valid URL starting with http:// or https://";
      }
    }

    if (activeTab === "STANDALONE_CALENDAR") {
      if (!formData.calendarStartTime) {
        newErrors.calendarStartTime = "Start Time is required";
      }
      if (!formData.calendarEndTime) {
        newErrors.calendarEndTime = "End Time is required";
      } else if (formData.calendarEndTime <= formData.calendarStartTime) {
        newErrors.calendarEndTime = "End Time must be after Start Time";
      }
      if (!formData.calendarTitle || formData.calendarTitle.trim() === "") {
        newErrors.calendarTitle = "Calendar Title is required";
      } else if (formData.calendarTitle.length < 2) {
        newErrors.calendarTitle =
          "Calendar Title must be at least 2 characters";
      } else if (formData.calendarTitle.length > 100) {
        newErrors.calendarTitle =
          "Calendar Title must be 100 characters or less";
      }
      if (
        !formData.calendarDescription ||
        formData.calendarDescription.trim() === ""
      ) {
        newErrors.calendarDescription = "Calendar Description is required";
      } else if (formData.calendarDescription.length < 2) {
        newErrors.calendarDescription =
          "Calendar Description must be at least 2 characters";
      } else if (formData.calendarDescription.length > 500) {
        newErrors.calendarDescription =
          "Calendar Description must be 500 characters or less";
      }
    }

    if (activeTab === "STANDALONE_LOCATION") {
      if (!formData.latitude) {
        newErrors.latitude = "Latitude is required";
      } else if (
        isNaN(formData.latitude) ||
        formData.latitude < -90 ||
        formData.latitude > 90
      ) {
        newErrors.latitude = "Latitude must be a number between -90 and 90";
      }
      if (!formData.longitude) {
        newErrors.longitude = "Longitude is required";
      } else if (
        isNaN(formData.longitude) ||
        formData.longitude < -180 ||
        formData.longitude > 180
      ) {
        newErrors.longitude = "Longitude must be a number between -180 and 180";
      }
      if (!formData.locationLabel || formData.locationLabel.trim() === "") {
        newErrors.locationLabel = "Location Label is required";
      } else if (formData.locationLabel.length < 2) {
        newErrors.locationLabel =
          "Location Label must be at least 2 characters";
      } else if (formData.locationLabel.length > 100) {
        newErrors.locationLabel =
          "Location Label must be 100 characters or less";
      }
    }

    if (activeTab === "STANDALONE_DIALER") {
      const phone = formData.phoneNumber ? formData.phoneNumber.trim() : "";

      if (!phone) {
        newErrors.phoneNumber = "Contact is required";
      } else if (phone.length < 10) {
        newErrors.phoneNumber = "Phone number must be at least 10 digits";
      } else if (!startsWith6789.test(phone)) {
        newErrors.phoneNumber = "Phone number must start with 6, 7, 8, or 9";
      } else if (repetitiveNumberPattern.test(phone)) {
        newErrors.phoneNumber = "Repetitive phone numbers are not allowed";
      }
    }

    if (activeTab === "STANDALONE_COMBINED") {
      if (!formData.dialerPlainText || formData.dialerPlainText.trim() === "") {
        newErrors.dialerPlainText = "Dialer Plain Text is required";
      } else if (formData.dialerPlainText.length < 2) {
        newErrors.dialerPlainText =
          "Dialer Plain Text must be at least 2 characters";
      } else if (formData.dialerPlainText.length > 50) {
        newErrors.dialerPlainText =
          "Dialer Plain Text must be 50 characters or less";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          fetchData(1);
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const now = new Date();
    const hours = now.getHours();
    if (hours < 9 || hours >= 21) {
      CustomAlert({
        title: "Info",
        text: "RCS services are available only between 9 AM to 9 PM. Please try later.",
        icon: "info",
        confirmButtonText: "Okay",
        allowOutsideClick: false,
      });
      return;
    }

    if (!isVerified && !isBulkUpload && activeLabel !== "Message with Name") {
      CustomAlert({
        title: "Info",
        text: "Please select either Check, Bulk or Bulk Name before proceeding.",
        icon: "info",
        confirmButtonText: "Okay",
        allowOutsideClick: false,
      });
      return;
    }
    if (!validateForm()) {
      CustomAlert({
        title: "Error",
        text: "Please correct the errors in the form.",
        icon: "error",
        confirmButtonText: "Okay",
      });
      return;
    }

    if (isBulkUpload) {
      handleCsvBulkUpload(activeTab);
    } else {
      sendRichCardApi(activeTab, formData);
    }

    console.log("Form Data Submitted:", formData);
  };

  function fullyDecode(value) {
    if (typeof value !== "string") {
        return value;
    }

    try {
        const decoded = decodeURIComponent(value);

        // Base case: decoding doesn't change the value anymore
        if (decoded === value) {
            return value;
        }

        // Continue decoding recursively
        return fullyDecode(decoded);
    } catch (e) {
        // Invalid encoding, return the last successfully decoded value
        return value;
    }
}

  const buildPayload = (type, formData) => {
    let suggestions = [];

    switch (type) {
      case "STANDALONE_REPLY":
        suggestions = [
          {
            reply: {
              plainText: formData.plainText || "Yes, Absolutely",
              postBack: { data: "visit_now_election24{{$50}}" },
            },
          },
        ];
        break;
      case "STANDALONE_CALENDAR":
        // suggestions = [
        //   {
        //     action: {
        //       plainText: formData.plainText,
        //       postBack: { data: "SA1L1C1{{$50}}" },
        //       createCalendarEvent: {
        //         startTime: "2023-06-26T15:01:23Z",
        //         endTime: "2023-06-26T18:01:23Z",
        //         title: "RCS Seminar",
        //         description: "Session 1 of 4",
        //       },
        //     },
        //   },
        // ];
        suggestions = [
          {
            action: {
              plainText: formData.plainText,
              postBack: { data: "SA1L1C1{{$50}}" },
              createCalendarEvent: {
                startTime: formData.calendarStartTime
                  ? new Date(formData.calendarStartTime).toISOString()
                  : "",
                endTime: formData.calendarEndTime
                  ? new Date(formData.calendarEndTime).toISOString()
                  : "",
                title: formData.calendarTitle || "RCS Seminar",
                description: formData.calendarDescription || "Session 1 of 4",
              },
            },
          },
        ];
        break;
      case "STANDALONE_LOCATION":
        // suggestions = [
        //   {
        //     action: {
        //       plainText: formData.plainText,
        //       postBack: { data: "SA1L1C1{{$50}}" },
        //       showLocation: {
        //         coordinAtes: { latitude: 21.5937, longitude: 78.9629 },
        //         label: "Label - Show Location",
        //       },
        //     },
        //   },
        // ];
        suggestions = [
          {
            action: {
              plainText: formData.plainText,
              postBack: { data: "SA1L1C1{{$50}}" },
              showLocation: {
                coordinAtes: {
                  latitude: parseFloat(formData.latitude),
                  longitude: parseFloat(formData.longitude),
                },
                label: formData.locationLabel || "",
              },
            },
          },
        ];
        break;
      case "STANDALONE_DIALER":
        suggestions = [
          {
            action: {
              plainText: formData.plainText || "Dial Now",
              postBack: { data: "SA1L1C1{{$50}}" },
              dialerAction: {
                phoneNumber: `+91${formData.phoneNumber}` || "",
              },
            },
          },
        ];
        break;
      case "STANDALONE_OPENURL":
        suggestions = [
          {
            action: {
              plainText: formData.plainText,
              postBack: { data: "visit_now_election24{{$50}}" },
              openUrl: {
                url: encodeURI(fullyDecode(formData.url)) || "https://elections24.eci.gov.in/",
              },
            },
          },
        ];
        break;
      case "STANDALONE_COMBINED":
        suggestions = [
          {
            action: {
              plainText: formData.plainText,
              postBack: { data: "visit_now_election24{{$50}}" },
              openUrl: {
                url: encodeURI(fullyDecode(formData.url)) || "https://elections24.eci.gov.in/",
              },
            },
          },
          {
            action: {
              plainText: formData.dialerPlainText || "Dial Now",
              postBack: { data: "SA1L1C1{{$50}}" },
              dialerAction: {
                phoneNumber: formData.phoneNumber
                  ? `+91${formData.phoneNumber.replace(/^\+91/, "")}`
                  : "",
              },
            },
          },
        ];
        break;
      case "STANDALONE_SEND":
      default:
        suggestions = [
          {
            action: {
              plainText: formData.plainText,
              postBack: {
                data: formData.postBackData || "visit_now_election24{{$50}}",
              },
              openUrl: {
                url: encodeURI(fullyDecode(formData.url)) || "https://elections24.eci.gov.in/",
              },
            },
          },
        ];
        break;
    }

    console.log("➡️ Payload type is:", type);

    return {
      contacts: [formData.contacts],
      campaignID: formData.campaignID,
      data: {
        content: {
          richCardDetails: {
            standalone: {
              cardOrientation: formData.cardOrientation || "VERTICAL",
              content: {
                cardTitle: formData.cardTitle || "",
                cardDescription: formData.cardDescription || "",
                cardMedia: {
                  mediaHeight: "MEDIUM",
                  contentInfo: { fileUrl: formData.fileUrl || "" },
                },
                suggestions,
              },
            },
          },
        },
      },
    };
  };

  const resolveEndpoint = (type) => {
    switch (type) {
      case "STANDALONE_SEND":
        return apiList.SEND_RICH_CARD;
      case "STANDALONE_REPLY":
        return apiList.SEND_RICH_REPLY_CARD;
      case "STANDALONE_CALENDAR":
        return apiList.SEND_RICH_CALENDAR_CARD;
      case "STANDALONE_LOCATION":
        return apiList.SEND_RICH_LOCATION_CARD;
      case "STANDALONE_DIALER":
        return apiList.SEND_RICH_DIALER_CARD;
      case "STANDALONE_OPENURL":
        return apiList.SEND_RICH_OPEN_URL_CARD;
      case "STANDALONE_COMBINED":
        return apiList.SEND_RICH_COMBINED_CARD;
      default:
        return "undefined";
    }
  };

  const tabsWithBulkName = [
    "STANDALONE_SEND",
    "STANDALONE_REPLY",
    "STANDALONE_CALENDAR",
    "STANDALONE_LOCATION",
    "STANDALONE_DIALER",
    "STANDALONE_OPENURL",
    "STANDALONE_COMBINED",
  ];

  const sendRichCardApi = async (type, formData) => {
    try {
      console.log(`Payload type is: ${type}`);

      const payload = buildPayload(type, formData);
      const endpoint = resolveEndpoint(type);

      payload.username = loggedInUserName;

      if (payload.contacts?.[0]) {
        payload.contacts[0] = `+91${payload.contacts[0]}`;
      }

      const headers = {
        rcskey: rcsAgentId,
      };

      const response = await axiosPostApi(endpoint, payload, headers);

      if (response?.data?.meta?.status === "00") {
        CustomAlert({
          title: "Success",
          text: response?.data?.meta?.message,
          icon: "success",
          confirmButtonText: "Okay",
        }).then(() => {
          fetchDashboardData();
        });
        setFormData({
          contacts: "",
          cardOrientation: "VERTICAL",
          cardTitle: "",
          cardDescription: "",
          fileUrl: "",
          plainText: "",
          url: "",
          calendarStartTime: "",
          calendarEndTime: "",
          calendarTitle: "",
          calendarDescription: "",
          latitude: "",
          longitude: "",
          locationLabel: "",
          phoneNumber: "",
          dialerPlainText: "",
        });
        setIsVerified(false);
        setIsBulkUpload(false);
        setCapabilityResult("");
        setBulkType("");
        setCsvFile("");
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.meta?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while sending the rich card.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const disableBtn = isBulkUpload || isVerified;

  const handleCsvBulkUpload = (type) => {
    if (!csvFile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        csv: "Please select a CSV file before uploading.",
      }));
      return;
    }
    const payload = buildPayload(type, formData);
    const formDataA = new FormData();
    formDataA.append("username", loggedInUserName);
    formDataA.append("rcsType", activeTab);
    formDataA.append("rcsMessage", JSON.stringify(payload));
    formDataA.append("file", csvFile);
    formDataA.append("isNameRequired", isNameRequired);

    try {
      bulkUpload(formDataA);
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const bulkUpload = async (payload) => {
    // setLoading(true);
    try {
      // Make the API call
      const response = await axiosPostApi(
        apiList.RCS_UPLOAD_MOBILE_EXCEL,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.status === 200 && response?.data?.respCode === "00") {
        // setShowSuccessModal(true);
        // haldleSetEmptyField();
        // setsuccessMessage(response?.data?.message);
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Okay",
        }).then(() => {
          fetchDashboardData();
        });
        setFormData({
          contacts: "",
          cardOrientation: "VERTICAL",
          cardTitle: "",
          cardDescription: "",
          fileUrl: "",
          plainText: "",
          url: "",
          calendarStartTime: "",
          calendarEndTime: "",
          calendarTitle: "",
          calendarDescription: "",
          latitude: "",
          longitude: "",
          locationLabel: "",
          phoneNumber: "",
          dialerPlainText: "",
          bulkFileName: "",
        });
        setBulkFileName(null);
        setIsBulkUpload(false);
      } else if (response?.data?.respCode === "05") {
        CustomAlert({
          title: "Info",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "info",
          confirmButtonText: "Retry",
        });
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      // setLoading(false);
    }
  };

  const fields = [
    ...(activeTab === "STANDALONE_SEND" && activeLabel === "Message with Name"
      ? [
          {
            render: () => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <button
                    className="btn addUser"
                    onClick={() => setShowModal(true)}
                    type="button"
                    // disabled={disableBtn}
                  >
                    Bulk Upload <TiPlus />
                  </button>
                </div>
                {formData.bulkFileName && (
                  <div className="flex items-center">
                    <div
                      style={{
                        padding: "8px 12px",
                        borderRadius: "40px",
                        backgroundColor: "#e0f7fa",
                        color: "#007c91",
                        fontSize: "16px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        maxWidth: "300px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span>{formData.bulkFileName}</span>
                    </div>

                    {/* ❌ Icon separate from the bubble */}
                    <button
                      type="button"
                      onClick={() => {
                        setBulkFileName(null);
                        setCsvFile(null);
                        setIsBulkUpload(false);
                        setIsVerified(false);
                        setCapabilityResult("");
                        setBulkType("");
                        setFormData((prev) => ({
                          ...prev,
                          bulkFileName: "",
                        }));
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#d32f2f",
                        fontSize: "20px",
                        cursor: "pointer",
                        lineHeight: 1,
                      }}
                      title="Remove file"
                    >
                      ❌
                    </button>
                  </div>
                )}
              </div>
            ),
          },
          {
            // label: "Bulk File Name",
            name: "bulkFileName",
            type: "fileName",
            placeholder: "Bulk File Name",
            readOnly: true,
          },
        ]
      : [
          {
            label: "Campaign ID",
            name: "campaignID",
            type: "text",
            placeholder: "Enter campaign ID",
          },
          {
            label: "Contact",
            name: "contacts",
            type: "custom",
            render: () => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Contact Input */}
                  <input
                    type="text"
                    name="contacts"
                    value={formData.contacts}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter phone number"
                    disabled={isBulkUpload}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "10px",
                      border: errors.contacts ? "1px solid red" : "none",
                      backgroundColor: isBulkUpload ? "#e0e0e0" : "#f1f1f1",
                      boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                      fontSize: "16px",
                      width: "220px",
                      height: "40px",
                    }}
                  />

                  {/* Check Button */}
                  <button
                    type="button"
                    onClick={checkCapability}
                    disabled={
                      checking ||
                      !rcsAgentId ||
                      verifiedPhones.includes(formData.contacts)
                    }
                    style={{
                      padding: "8px 12px",
                      borderRadius: "10px",
                      border: "none",
                      backgroundColor: "#00BCD4",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "bold",
                      minWidth: "100px",
                      height: "40px",
                      cursor:
                        checking ||
                        !rcsAgentId ||
                        disableBtn ||
                        verifiedPhones.includes(formData.contacts)
                          ? "not-allowed"
                          : "pointer",
                      opacity:
                        checking ||
                        !rcsAgentId ||
                        disableBtn ||
                        verifiedPhones.includes(formData.contacts)
                          ? 0.6
                          : 1,
                    }}
                  >
                    {checking ? (
                      <CircularProgress
                        style={{ width: "20px", height: "20px" }}
                      />
                    ) : (
                      "Check"
                    )}
                  </button>

                  {/* OR + Bulk */}
                  <span>OR</span>
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(true);
                      setBulkType("bulk");
                      setIsNameRequired(false);
                    }}
                    disabled={disableBtn}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "10px",
                      border: "none",
                      backgroundColor: "#00BCD4",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "bold",
                      minWidth: "90px",
                      height: "40px",
                      cursor: disableBtn ? "not-allowed" : "pointer",
                      opacity: disableBtn ? 0.6 : 1,
                    }}
                  >
                    Bulk
                  </button>

                  {/* OR + Bulk Name */}
                  {tabsWithBulkName.includes(activeTab) && (
                    <>
                      <span>OR</span>
                      <button
                        type="button"
                        onClick={() => {
                          setShowModal(true);
                          setBulkType("name");
                          setIsNameRequired(true);
                        }}
                        disabled={
                          checking ||
                          !rcsAgentId ||
                          verifiedPhones?.includes(formData?.contacts)
                        }
                        style={{
                          padding: "8px 12px",
                          borderRadius: "10px",
                          border: "none",
                          backgroundColor: "#00BCD4",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "bold",
                          minWidth: "120px",
                          height: "40px",
                          cursor:
                            checking ||
                            !rcsAgentId ||
                            disableBtn ||
                            verifiedPhones.includes(formData.contacts)
                              ? "not-allowed"
                              : "pointer",
                          opacity:
                            checking ||
                            !rcsAgentId ||
                            disableBtn ||
                            verifiedPhones.includes(formData.contacts)
                              ? 0.6
                              : 1,
                          whiteSpace: "nowrap",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        Bulk Name
                      </button>
                    </>
                  )}
                </div>

                {errors.contacts && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errors.contacts}
                  </span>
                )}
                {formData.bulkFileName && (
                  <div className="flex items-center">
                    <div
                      style={{
                        padding: "8px 12px",
                        borderRadius: "40px",
                        backgroundColor: "#e0f7fa",
                        color: "#007c91",
                        fontSize: "16px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        maxWidth: "300px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span>{formData.bulkFileName}</span>
                    </div>

                    {/* ❌ Icon separate from the bubble */}
                    <button
                      type="button"
                      onClick={() => {
                        setBulkFileName(null);
                        setCsvFile(null);
                        setIsBulkUpload(false);
                        setIsVerified(false);
                        setCapabilityResult("");
                        setBulkType("");
                        setFormData((prev) => ({
                          ...prev,
                          bulkFileName: "",
                        }));
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#d32f2f",
                        fontSize: "20px",
                        cursor: "pointer",
                        lineHeight: 1,
                      }}
                      title="Remove file"
                    >
                      ❌
                    </button>
                  </div>
                )}
                {isVerified && verifiedPhones.includes(formData.contacts) ? (
                  <span
                    style={{
                      fontSize: "14px",
                      marginLeft: "8px",
                      color: "green",
                    }}
                  >
                    Verified
                  </span>
                ) : (
                  capabilityResult && (
                    <span style={{ fontSize: "14px" }}>{capabilityResult}</span>
                  )
                )}
              </div>
            ),
          },
          // {
          //   // label: "Bulk File Name",
          //   name: "bulkFileName",
          //   type: "fileName",
          //   placeholder: "Bulk File Name",
          //   readOnly: true,
          // },
        ]),

    {
      label: "Card Orientation",
      name: "cardOrientation",
      type: "select",
      options: [
        { value: "VERTICAL", label: "VERTICAL" },
        { value: "HORIZONTAL", label: "HORIZONTAL" },
      ],
    },
    {
      label: "Card Title",
      name: "cardTitle",
      type: "text",
      placeholder: "Enter card title",
    },
    {
      label: "File URL",
      name: "fileUrl",
      type: "text",
      placeholder: "Enter image URL",
    },
    {
      label: "Plain Text",
      name: "plainText",
      type: "text",
      placeholder: "Enter plain text",
    },
    ...(activeTab !== "STANDALONE_REPLY" &&
    activeTab !== "STANDALONE_CALENDAR" &&
    activeTab !== "STANDALONE_DIALER"
      ? [
          {
            label: "URL",
            name: "url",
            type: "text",
            placeholder: "Enter URL",
          },
        ]
      : []),
    ...(activeTab === "STANDALONE_CALENDAR"
      ? [
          {
            label: "Start Time",
            name: "calendarStartTime",
            type: "datetime-local",
            placeholder: "Enter Start Time",
            min: new Date().toISOString().slice(0, 16),
            max: "2035-12-31T23:59",
          },
          {
            label: "End Time",
            name: "calendarEndTime",
            type: "datetime-local",
            placeholder: "Enter End Time",
            min:
              formData.calendarStartTime ||
              new Date().toISOString().slice(0, 16),
            max: "2035-12-31T23:59",
          },
          {
            label: "Calendar Title",
            name: "calendarTitle",
            type: "text",
            placeholder: "Enter Calendar Title",
          },
          {
            label: "Calendar Description",
            name: "calendarDescription",
            type: "text",
            placeholder: "Enter Calendar Description",
          },
        ]
      : []),
    ...(activeTab === "STANDALONE_LOCATION"
      ? [
          {
            label: "Latitude",
            name: "latitude",
            type: "number",
            placeholder: "Fetching latitude...",
            readOnly: true,
          },
          {
            label: "Longitude",
            name: "longitude",
            type: "number",
            placeholder: "Fetching longitude...",
            readOnly: true,
          },
          {
            label: "Location",
            name: "locationLabel",
            type: "text",
            placeholder: "Enter Location Label",
          },
        ]
      : []),
    ...(activeTab === "STANDALONE_DIALER"
      ? [
          {
            label: "Phone Number",
            name: "phoneNumber",
            type: "text",
            placeholder: "Enter Phone Number",
            // readOnly: true,
          },
        ]
      : []),
    ...(activeTab === "STANDALONE_COMBINED"
      ? [
          // {
          //   label: "URL Plain Text",
          //   name: "urlPlainText",
          //   type: "text",
          //   placeholder: "Enter URL plain text",
          // },
          {
            label: "Dialer Plain Text",
            name: "dialerPlainText",
            type: "text",
            placeholder: "Enter dialer plain text",
          },
          // {
          //   label: "URL",
          //   name: "url",
          //   type: "text",
          //   placeholder: "Enter URL",
          //   readOnly: true,
          // },
          {
            label: "Phone Number",
            name: "phoneNumber",
            type: "text",
            placeholder: "Enter Phone Number",
            // readOnly: true,
          },
        ]
      : []),
    {
      label: "Card Description",
      name: "cardDescription",
      type: "textarea",
      placeholder: "Enter card description",
    },
  ];

  const getRedirectUrl = () => {
    const tabsWithoutUrl = [
      "STANDALONE_REPLY",
      "STANDALONE_CALENDAR",
      "STANDALONE_DIALER",
    ];
    if (tabsWithoutUrl.includes(activeTab)) return null;

    const url = formData.url?.trim();
    if (!url) return null;

    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "32px",
        flexWrap: "wrap",
        alignItems: "flex-start",
        padding: "24px",
      }}
    >
      <div
        style={{
          flex: "1 1 50%",
          overflowY: "auto",
          maxHeight: "100%",
          padding: "16px",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h2 style={{ color: "#00b6CE", marginBottom: "20px" }}>
          {`RCS ${
            activeLabel ||
            (activeTab === "STANDALONE_OPENURL" && "Open URL") ||
            (activeTab === "STANDALONE_CALENDAR" && "Calendar Event") ||
            (activeTab === "STANDALONE_REPLY" && "Suggested Reply") ||
            (activeTab === "STANDALONE_LOCATION" && "Share Location") ||
            (activeTab === "STANDALONE_DIALER" && "Dialer Action") ||
            (activeTab === "STANDALONE_COMBINED" && "Combination") ||
            (activeTab === "STANDALONE_SEND" && "Send Message")
          }`}
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            // maxWidth: "800px",
            // flexShrink: 1,
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              // gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              // maxWidth: "800px",
              // maxWidth: "400px",
              // width: "100%",
            }}
          >
            {fields.map(
              ({
                label,
                name,
                type,
                render,
                options,
                placeholder,
                readOnly,
                min,
                max,
              }) => (
                <div
                  key={name}
                  style={{
                    marginBottom: "20px",
                    display: type === "fileName" ? "flex" : "",
                    alignItems: type === "fileName" ? "end" : "",
                    justifyContent:
                      activeTab === "STANDALONE_SEND" ? "end" : "",
                    visibility:
                      !bulkFileName && type === "fileName" ? "hidden" : "",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    {label}
                  </label>
                  {render ? (
                    render()
                  ) : type === "select" ? (
                    <>
                      <select
                        name={name}
                        value={formData[name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          padding: "8px 12px",
                          borderRadius: "10px",
                          border: errors[name] ? "1px solid red" : "none",
                          backgroundColor: "#f1f1f1",
                          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                          fontSize: "16px",
                          width: "100%",
                          height: "40px",
                          outline: "none",
                          transition: "box-shadow 0.2s ease-in-out",
                        }}
                        onFocus={(e) =>
                          (e.target.style.boxShadow =
                            "0 0 0 2px rgba(0, 122, 255, 0.5)")
                        }
                      >
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      {errors[name] && (
                        <span style={{ color: "red", fontSize: "14px" }}>
                          {errors[name]}
                        </span>
                      )}
                    </>
                  ) : type === "textarea" ? (
                    <>
                      <textarea
                        name={name}
                        value={formData[name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder={placeholder}
                        style={{
                          padding: "8px 12px",
                          borderRadius: "10px",
                          border: errors[name] ? "1px solid red" : "none",
                          backgroundColor: "#f1f1f1",
                          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                          fontSize: "16px",
                          width: "100%",
                          height: "100px",
                          outline: "none",
                          transition: "box-shadow 0.2s ease-in-out",
                          resize: "vertical",
                        }}
                        onFocus={(e) =>
                          (e.target.style.boxShadow =
                            "0 0 0 2px rgba(0, 122, 255, 0.5)")
                        }
                      />
                      {errors[name] && (
                        <span style={{ color: "red", fontSize: "14px" }}>
                          {errors[name]}
                        </span>
                      )}
                    </>
                  ) : type === "fileName" ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginTop: "3px",
                        // visibility: !formData?.bulkFileName ? "hidden" : "",
                        // display: !formData?.bulkFileName ? "none" : "flex",
                        marginLeft: "auto",
                      }}
                    >
                      {/* Bubble for file name */}
                      <div
                        style={{
                          padding: "8px 12px",
                          borderRadius: "40px",
                          backgroundColor: "#e0f7fa",
                          color: "#007c91",
                          fontSize: "16px",
                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          maxWidth: "300px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          cursor: readOnly ? "not-allowed" : "text",
                        }}
                      >
                        <span>{formData.bulkFileName}</span>
                      </div>

                      {/* ❌ Icon separate from the bubble */}
                      <button
                        type="button"
                        onClick={() => {
                          setBulkFileName(null);
                          setCsvFile(null);
                          setIsBulkUpload(false);
                          setIsVerified(false);
                          setCapabilityResult("");
                          setBulkType("");
                          setFormData((prev) => ({
                            ...prev,
                            bulkFileName: "",
                          }));
                        }}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "#d32f2f",
                          fontSize: "20px",
                          cursor: "pointer",
                          lineHeight: 1,
                        }}
                        title="Remove file"
                      >
                        ❌
                      </button>
                    </div>
                  ) : (
                    <>
                      <input
                        type={type}
                        name={name}
                        value={formData[name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder={placeholder}
                        readOnly={readOnly}
                        min={min}
                        max={max}
                        style={{
                          padding: "8px 12px",
                          borderRadius: "10px",
                          border: errors[name] ? "1px solid red" : "none",
                          backgroundColor: readOnly ? "#e0e0e0" : "#f1f1f1",
                          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                          fontSize: "16px",
                          width: "100%",
                          height: "40px",
                          outline: "none",
                          transition: "box-shadow 0.2s ease-in-out",
                          cursor: readOnly ? "not-allowed" : "text",
                        }}
                        onFocus={(e) =>
                          !readOnly &&
                          (e.target.style.boxShadow =
                            "0 0 0 2px rgba(0, 122, 255, 0.5)")
                        }
                      />
                      {errors[name] && (
                        <span style={{ color: "red", fontSize: "14px" }}>
                          {errors[name]}
                        </span>
                      )}
                    </>
                  )}
                </div>
              )
            )}
          </div>
          <button
            type="submit"
            style={{
              backgroundColor: isHovered || isActive ? "#ffffff" : "#00BCD4",
              color: isHovered || isActive ? "#00B6CE" : "#ffffff",
              border: isHovered || isActive ? "1px solid #00B6CE" : "none",
              padding: "12px 36px",
              fontSize: "16px",
              fontWeight: "600",
              borderRadius: "999px",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              transition:
                "transform 0.1s ease-in-out, background-color 0.3s, color 0.3s, border 0.3s",
              alignSelf: "center",
              marginTop: "30px",
              transform: isActive ? "scale(0.95)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onMouseDown={() => setIsActive(true)}
            onMouseUp={() => setIsActive(false)}
          >
            Send
          </button>
        </form>
      </div>

      {/* ───────────────────────── Live Preview ───────────────────────── */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          padding: "24px",
          flex: "1 1 520px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h2 style={{ color: "#00b6CE", marginBottom: "20px" }}>Live Preview</h2>

        {/* ---------- Card shell ---------- */}
        <div
          style={{
            border: "1px solid #E0E0E0",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,.05)",
            overflow: "hidden",
            display:
              formData.cardOrientation === "HORIZONTAL" ? "flex" : "block",
            flexDirection:
              formData.cardOrientation === "HORIZONTAL" ? "row" : "column",
            alignItems:
              formData.cardOrientation === "HORIZONTAL" ? "center" : "stretch",
          }}
        >
          {/* ---------- Image ---------- */}
          <img
            src={formData.fileUrl}
            alt="preview"
            style={{
              width: formData.cardOrientation === "HORIZONTAL" ? "50%" : "100%",
              borderRadius: "4px",
              marginRight:
                formData.cardOrientation === "HORIZONTAL" ? "15px" : "0",
              marginBottom:
                formData.cardOrientation === "HORIZONTAL" ? "0" : "10px",
              objectFit: "cover",
            }}
          />

          {/* ---------- Text column ---------- */}
          <div
            style={{
              padding: "20px 24px",
              flex: formData.cardOrientation === "HORIZONTAL" ? "1" : "0",
            }}
          >
            {/* Title */}
            <h3
              style={{
                margin: "0 0 10px 0",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {formData.cardTitle}
            </h3>

            {/* Description */}
            {formData.cardDescription?.trim() && (
              <p style={{ margin: "0 0 10px 0", fontWeight: 500 }}>
                {formData.cardDescription}
              </p>
            )}

            {/* on tab action row */}
            {(() => {
              const renderActionRow = (icon, text, href = null) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "24px",
                  }}
                >
                  {href ? (
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        textDecoration: "none",
                        color: "#5B6BA6",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          backgroundColor: "#E7EAF6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {icon}
                      </div>
                      <span>{text}</span>
                    </a>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        color: "#5B6BA6",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          backgroundColor: "#E7EAF6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {icon}
                      </div>
                      <span>{text}</span>
                    </div>
                  )}
                </div>
              );

              /* ---------- Single-mode tabs ---------- */
              const tabKeyMap = {
                STANDALONE_SEND: "send",
                STANDALONE_REPLY: "reply",
                STANDALONE_CALENDAR: "calendar",
                STANDALONE_LOCATION: "location",
                STANDALONE_DIALER: "dialer",
                STANDALONE_OPENURL: "openUrl",
              };

              const icons = {
                send: <FaGlobeAsia size={20} />,
                reply: <FaReply size={20} />,
                calendar: <FaRegCalendarAlt size={20} />,
                location: <FaMapMarkerAlt size={20} />,
                dialer: <FaPhoneAlt size={20} />,
                openUrl: <FaGlobeAsia size={20} />,
              };

              if (
                Object.keys(tabKeyMap).includes(activeTab) &&
                formData.plainText?.trim()
              ) {
                const key = tabKeyMap[activeTab];
                const href = getRedirectUrl();
                // if (!href) return null;

                return renderActionRow(icons[key], formData.plainText, href);
              }

              if (activeTab === "STANDALONE_COMBINED") {
                const url = getRedirectUrl();

                return (
                  <>
                    {formData.plainText?.trim() &&
                      renderActionRow(
                        <FaGlobeAsia size={20} />,
                        formData.plainText,
                        url
                      )}

                    {formData.dialerPlainText?.trim() &&
                      renderActionRow(
                        <FaPhoneAlt size={20} />,
                        formData.dialerPlainText,
                        null
                      )}
                  </>
                );
              }

              return null;
            })()}
          </div>
        </div>
      </div>
      <RcsBulkMessageModal
        show={showModal}
        handleClose={handleCloseModal}
        // callApi={() => fetchBulkSmsData(1)}
        activeTab={activeTab}
        setIsBulkUpload={setIsBulkUpload}
        setBulkFileName={setBulkFileName}
        setCsvFile={setCsvFile}
        csvFile={csvFile}
        bulkType={bulkType}
      />
    </div>
  );
};

export default RCSStandaloneMsg;
